module.exports = __webpack_public_path__ + "img/expand.31d24f80.svg";